// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelFilterForm_root__Lx1QC","inputSelectedCountBadge":"TravelFilterForm_inputSelectedCountBadge__gaoL9","input":"TravelFilterForm_input__gpAVE"};